import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  ListGroup,
  ListGroupItem,
  Badge,
  Col,
  Row
} from 'reactstrap';
import PropTypes from 'prop-types';
import NetworkEmptyState from './networkemptystate';
import Loader from './loader';
import NumberFormatter from './NumberFormatter';

const propTypes = {
  modalTitle: PropTypes.string,
  buttonText: PropTypes.string,
  disabled: PropTypes.bool,
  buttonColor: PropTypes.string,
  raktarak: PropTypes.array,
  handleListItemClick: PropTypes.func.isRequired,
  getData: PropTypes.func.isRequired,
  formKeszletCikkId: PropTypes.number,
  formKeszletCikkszam: PropTypes.string,
  formKeszletCikknev: PropTypes.string,
  formKeszletRaktarId: PropTypes.object,
  loadingStatus: PropTypes.string,
};

const defaultProps = {
  buttonText: 'Készletinformáció',
  modalTitle: 'Készletinformáció',
  buttonColor: 'success',
  raktarak: [],
  disabled: false,
};

/**
 * Készletinformáció megtekintő / raktár választó modal
 *
 * @version 1.0.0
 * @author [Nagy Gergely](https://github.com/gergely-nagy)
 */
class KeszletInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      currentSzabad: null,
      currentRaktarID: null,
      currentRaktarNev: null,
    };
  }

  toggleModal = () => {
    this.setState(prevState => ({ modalOpen: !prevState.modalOpen }));
  }

  renderRaktarak = () => {
    return this.props.raktarak.map((item) => {
      return (
        <ListGroupItem
          style={{ cursor: 'pointer' }}
          color="#ede"
          active={item.raktar.selected}
          key={item.id}
          className='no-gutters'
          onClick={() => {
            this.props.handleListItemClick(item.raktar.id, item.raktar.nev);
            this.setState({
              currentSzabad: item.szabadMennyiseg,
              currentRaktarID: item.raktar.id,
              currentRaktarNev: item.raktar.nev,
            });
          }}
        >
          <Col className="row no-gutters justify-content-between">
            <Col  md="6">
              {item.raktar.nev + ' ( ' + item.raktar.azonosito + ' )'}
            </Col>
            <Col md="2" className='row no-gutters justify-content-center'>
              <Col md="auto">
                <Badge color="teljes" className='m-0' pill style={{ marginLeft: 5 }}>
                {NumberFormatter.addSpacesToString(item.teljesMennyiseg, NumberFormatter.OSSZEG)}
              </Badge>
              </Col>
            </Col>
            <Col md="2" className='row no-gutters justify-content-center'>
              <Col md="auto">
                <Badge color="foglalt" className='m-0' pill style={{ marginLeft: 5 }}>
                  {NumberFormatter.addSpacesToString(item.foglaltMennyiseg, NumberFormatter.OSSZEG)}
                </Badge>
              </Col>
            </Col>
            {/* <Badge pill color="varhato" style={{ marginLeft: 5 }}>
                  3
            </Badge> */}
            <Col md="2" className='row no-gutters justify-content-center'>
              <Col md="auto">
                <Badge color="szabad" className='m-0' pill style={{ marginLeft: 5 }}>
                  {NumberFormatter.addSpacesToString(item.szabadMennyiseg, NumberFormatter.OSSZEG)}
                </Badge>
              </Col>
            </Col>
          </Col>
        </ListGroupItem>
      );
    });
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  renderKeszletInfoLogic = () => {
    return (
      <React.Fragment>
        <div className='mb-1'>
          <Label for="formKeszletCikkszam">Cikkszám:</Label>
          <Input
            name="formKeszletCikkszam"
            id="formKeszletCikkszam"
            value={this.props.formKeszletCikkszam}
            disabled
          />
        </div>
        <div className='mb-1'>
          <Label for="formKeszletCikknev">Cikknév:</Label>
          <Input
            name="formKeszletCikknev"
            id="formKeszletCikknev"
            value={this.props.formKeszletCikknev}
            disabled
          />
        </div>
        <ListGroup>
          {this.renderRaktarak()}
        </ListGroup>
        <div>
          <Row className='justify-content-center no-gutters' style={{ padding: "0 1.25rem"}}>
            <Col md="6" className='row no-gutters justify-content-end'>
              <Col md="auto">
                Készlet:
              </Col>
            </Col>
            <Col md="2"
            className='row no-gutters justify-content-center'>
              <Col md="auto">
                <Badge color="teljes" pill>
                  {'Teljes'}
                </Badge>
              </Col>
            </Col>
            <Col md="2" className='row no-gutters justify-content-center'>
              <Col md="auto">
                <Badge color="foglalt" pill>
                  {'Foglalt'}
                </Badge>
              </Col>
            </Col>
            <Col md="2" className='row no-gutters justify-content-center'>
              <Col md="auto">
                <Badge color="szabad" pill>
                  {'Szabad'}
                </Badge>
              </Col>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }

  render() {
    return (
      <React.Fragment>
        <Button
          onClick={() => {
            this.setState({ modalOpen: true }, () => {
              this.props.getData();
            });
          }}
          disabled={this.props.disabledButton}
          color={this.props.buttonColor}
          style={{ marginTop: 30 }}
        >
          {this.props.buttonText}
        </Button>
        {/* <Badge color="szabad" pill style={{ marginLeft: 5 }}>
          {this.props.selectedSzabad ? this.props.selectedSzabad + ' szabad mennyiség' : 'Nincs kiválasztott raktár!'}
        </Badge> */}
        <Modal
          isOpen={this.state.modalOpen}
          toggle={this.toggleModal}
          // className={this.props.className}
          backdrop="static"
          // size="lg"
        >
          <ModalHeader>{this.props.modalTitle}</ModalHeader>
          <ModalBody>
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                // submitClick={() => this.getVizsgalo(this.state.currentId)}
              />),
              DATA: (this.renderKeszletInfoLogic())
            }[this.props.loadingStatus]}
          </ModalBody>
          <ModalFooter>
            {this.emptyOrNull(this.state.currentRaktarID) && (
              <Button className="btn-cursor-pointer" type="button" color="primary" onClick={() => {
                this.toggleModal();
                if (this.props.onSave) this.props.onSave(this.state.currentRaktarID, this.state.currentSzabad, this.state.currentRaktarNev);
              }}
              >
                {'Mentés'}
              </Button>
            )}
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleModal}>Bezárás</Button>
          </ModalFooter>
        </Modal>
      </React.Fragment>
    );
  }
}

KeszletInfo.propTypes = propTypes;
KeszletInfo.defaultProps = defaultProps;

export default KeszletInfo;
